import {
  UsersUserIdPersonalAccessTokensPostRequest,
  UsersUserIdPersonalAccessTokensTokenIdDeleteRequest,
} from '@nativewaves/nw-cloud-sdk/identity'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { IdentityAPI } from 'services/api'
import { userQueryKeys } from 'services/queryKeys/identity'

export const usePersonalAccessTokenCreateMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (params: UsersUserIdPersonalAccessTokensPostRequest) =>
      IdentityAPI.users.usersUserIdPersonalAccessTokensPost(params),
    onSuccess: () => {
      return queryClient.invalidateQueries({ queryKey: userQueryKeys.personalAccessTokenLists() })
    },
  })
}

export const usePersonalAccessTokenDeleteMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (params: UsersUserIdPersonalAccessTokensTokenIdDeleteRequest) =>
      IdentityAPI.users.usersUserIdPersonalAccessTokensTokenIdDelete(params),
    onSuccess: () => {
      return queryClient.invalidateQueries({ queryKey: userQueryKeys.personalAccessTokenLists() })
    },
  })
}
